"use client";

import { cn } from "@/lib/utils";

interface LocationFilterOptionProps {
  emoji: string;
  label: string;
  selected: boolean;
  onClick: () => void;
  compact?: boolean;
}

export function LocationFilterOption({
  emoji,
  label,
  selected,
  onClick,
  compact = false,
}: LocationFilterOptionProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onClick}
      className={cn(
        "group flex min-h-12 w-full items-center gap-3 rounded-xl border text-left font-medium transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-600 focus-visible:ring-offset-2",
        compact ? "px-3 py-2 text-sm" : "px-3.5 py-3 text-sm sm:text-base",
        selected
          ? "border-brand-green-line bg-brand-green-soft text-brand-green shadow-sm"
          : "border-line bg-panel text-muted hover:-translate-y-0.5 hover:border-brand-green-line hover:shadow-sm",
      )}
    >
      <span
        aria-hidden="true"
        className={cn(
          "flex shrink-0 items-center justify-center rounded-lg bg-raised transition-colors",
          compact ? "h-8 w-8 text-lg" : "h-10 w-10 text-xl",
          selected && "bg-brand-green-soft",
        )}
      >
        {emoji || "🌍"}
      </span>
      <span className="min-w-0 truncate">{label}</span>
    </button>
  );
}
